<template>
  <div>
  <div>

    <!-- <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt">产业发展</div> -->
    <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt"><em>*</em>地方产业</div>
    <div class="c-profile-rt-input">
      <!-- <div style="display: flex;">
            <span>一带一路</span>
            <input style="margin-left: 20px;windth: 100px;" v-model="nation" @change="emitData" type="text" placeholder="请填写国家名,多个国家请用','分开.如:意大利,葡萄牙">
          </div> -->
      <!-- <div style="margin: 15px 0;"></div> -->
      <!-- <p><span style="margin-right: 20px">地方产业</span> <el-checkbox v-model="checkAll1" @change="handleCheckAllChange1">全选</el-checkbox> </p>-->
      <el-checkbox-group v-model="checkedIndustrycategories1" @change="handleIndustrycategoryChange1">
        <el-checkbox v-for="category,index in industrycategories.industryDev.local.list" :label="category" :key="category" :id="'df'+index"
          :ref="'df'+index" @change="selectOne('df'+index)">{{category}}</el-checkbox>
      </el-checkbox-group>
    </div>


  </div>
  <div>
    <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt"><em>*</em>地区国别</div>
    <div class="c-profile-rt-input">
      <!-- <p><span style="margin-right: 20px">地区国别</span> -->
      <!--<el-checkbox v-model="checkAll2" @change="handleCheckAllChange2">全选</el-checkbox></p>-->
      <el-checkbox-group v-model="checkedIndustrycategories2" @change="handleIndustrycategoryChange2">
        <el-checkbox v-for="category,index in industrycategories.industryDev.science.list" :label="category" :key="category" @change="selectOne2('dq'+index)" :id="'dq'+index"
          :ref="'dq'+index">{{category}}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
  </div>
</template>

<script>
  import {
    Checkbox,
    CheckboxGroup
  } from 'element-ui';

  export default {
    name: 'IndustryDev',
    props: {
      nation: {
        type: String
      },
      tag: {
        type: Object,
        default: () => {
          return {
            dfcy: '',
            kcpt: ''
          }
        }
      },
    },
    watch: {
      tag(n, o) {
        this.handleSelectedTagProps(n);
      },
    },
    components: {
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
    },
    data() {
      return {
        industrycategories: {

          industryDev: {
            name: '产业发展',
            local: {
              name: '地方产业',
              list: [
                '地方政府', '法人企业', '研究机构/大学', '行业组织'
              ]
            },
            science: {
              name: '科创平台',
              list: [
                '中国', '一带一路国家', '其他海外国家'
              ]
            },
          },
        },
        dfcy: '',
        kcpt: '',
        checkAll1: false,
        checkAll2: false,
        checkedIndustrycategories1: [],
        checkedIndustrycategories2: ['中国'],
      }
    },
    mounted() {},
    methods: {
      selectOne(ref) {
        this.checkedIndustrycategories1.splice(0, this.checkedIndustrycategories1.length)
        var cur = this.$refs[ref]
        var curname = cur[0].label
        this.checkedIndustrycategories1.push(curname)

      },
      selectOne2(ref) {
        this.checkedIndustrycategories2.splice(0, this.checkedIndustrycategories2.length)
        var cur = this.$refs[ref]
        var curname = cur[0].label
        this.checkedIndustrycategories2.push(curname)

      },
      handleSelectedTagProps(v) {
        if (v) {
          this.dfcy = v.dfcy
          this.kcpt = v.kcpt

          const optionsDfcy = this.dfcy && this.dfcy.split(';');
          if (optionsDfcy && optionsDfcy.length > 0) {
            this.checkedIndustrycategories1 = this.industrycategories.industryDev.local.list.filter((item) => {
              return optionsDfcy.includes(item);
            }) || [];
          }
          const optionsKcpt = this.kcpt && this.kcpt.split(';');
          if (optionsKcpt && optionsKcpt.length > 0) {
            this.checkedIndustrycategories2 = this.industrycategories.industryDev.science.list.filter((item) => {
              return optionsKcpt.includes(item);
            }) || [];
          }
          this.checkAll1 = this.checkedIndustrycategories1.length === this.industrycategories.industryDev.local.list.length;
          this.checkAll2 = this.checkedIndustrycategories2.length === this.industrycategories.industryDev.science.list.length;

          this.emitData();
        }
      },
      handleCheckAllChange1(val) {
        this.checkedIndustrycategories1 = val ? this.industrycategories.industryDev.local.list : [];
        this.handleCheckAll();
      },
      handleCheckAllChange2(val) {
        this.checkedIndustrycategories2 = val ? this.industrycategories.industryDev.science.list : [];
        this.handleCheckAll();
      },
      handleCheckAll() {
        this.checkAll1 = this.checkedIndustrycategories1.length === this.industrycategories.industryDev.local.list.length;
        this.checkAll2 = this.checkedIndustrycategories2.length === this.industrycategories.industryDev.science.list.length;
        this.emitData();
      },
      handleIndustrycategoryChange1(value) {
        // this.checkAll1 = value.length === this.industrycategories.industryDev.local.list.length;
        this.handleCheckAll();
      },
      handleIndustrycategoryChange2(value) {
        // this.checkAll2 = value.length === this.industrycategories.industryDev.science.list.length;
        this.handleCheckAll();
      },
      getCheckedCategories() {
        return [...this.checkedIndustrycategories1, ...this.checkedIndustrycategories2];
      },
      emitData() {
        this.$emit('dataChange', {
          checked: this.getCheckedCategories(),
          dfcy: this.checkedIndustrycategories1,
          kcpt: this.checkedIndustrycategories2,
          nation: this.nation
        });
      }
    }
  }
</script>

<style scoped>
</style>
